import {createAsyncThunk} from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import {BASE_URL} from "../../utils/constants";
import {getErrorMessage} from "../../utils/helper";

const APPROVAL_REQUEST_ENDPOINT = "approval-request";

export const fetchApprovalRequests = createAsyncThunk(
  "approvalRequests/fetch",
  async ({status, module, page = 1, limit = 10} = {}, {rejectWithValue}) => {
    try {
      const params = {page, limit};
      if (status) {
        params.status = status;
      }
      if (module) {
        params.module = module;
      }

      const response = await axiosInstance.get(
        `${BASE_URL}${APPROVAL_REQUEST_ENDPOINT}`,
        {
          params,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        getErrorMessage(error, "Failed to fetch approval requests")
      );
    }
  }
);

export const approveApprovalRequest = createAsyncThunk(
  "approvalRequests/approve",
  async ({id, reviewerComment}, {rejectWithValue}) => {
    try {
      const response = await axiosInstance.post(
        `${BASE_URL}${APPROVAL_REQUEST_ENDPOINT}/${id}/approve`,
        {reviewerComment}
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        getErrorMessage(error, "Failed to approve request")
      );
    }
  }
);

export const rejectApprovalRequest = createAsyncThunk(
  "approvalRequests/reject",
  async ({id, reviewerComment}, {rejectWithValue}) => {
    try {
      const response = await axiosInstance.post(
        `${BASE_URL}${APPROVAL_REQUEST_ENDPOINT}/${id}/reject`,
        {reviewerComment}
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        getErrorMessage(error, "Failed to reject request")
      );
    }
  }
);
